import { CultureInfo } from '../culture-info.model';

/**
 * @ignore
 */
export const CultureInfoTo: CultureInfo = {
  name: 'to',
  displayName: 'lea fakatonga',
  iso3LanguageCode: 'ton',
  iso2LanguageCode: 'to',
  ietfLanguageTag: 'to',
  parent: null
};
